import store from '@/store';
import type RootStateType from '@/store/types';
import { ActionContext, Module } from 'vuex';
import { getBanners } from '@/api/profile';
import { BannerSceneEnum } from '@/po/banner';
import generateMutations, {
  UPDATE_STATE_TYPE,
} from '@/store/generate-mutations';
import { getPackageOrange } from '@/api/transfer';
import type { StateType } from './types';

const moduleStore: Module<StateType, RootStateType> = {
  namespaced: true,
  state: {
    banners: [],
    rightsBanners: [],
  },
  actions: {
    async getBanners(
      context: ActionContext<StateType, RootStateType>,
    ): Promise<void> {
      try {
        context.dispatch(UPDATE_STATE_TYPE, {
          banners: await getBanners(BannerSceneEnum.mine),
        });
        return Promise.resolve();
      } catch (err) {
        return Promise.resolve();
      }
    },

    async getPackageOrange(
      context: ActionContext<StateType, RootStateType>,
    ): Promise<void> {
      try {
        context.dispatch(UPDATE_STATE_TYPE, {
          rightsBanners: await getPackageOrange(),
        });
        return Promise.resolve();
      } catch (err) {
        return Promise.resolve();
      }
    },


  },
};

store.registerModule('myProfile', generateMutations<StateType>(moduleStore));
